import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ToolsService } from 'src/app/@core/services/tools.service';

@Component({
  selector: 'app-iconos',
  templateUrl: './iconos.component.html',
  styleUrls: ['./iconos.component.scss']
})
export class IconosComponent {

  component: any;
  componentRender: any;
  infoComponent: any;
  iconSelected: '';
  arrIcon: string[];
  arrIconFilter: string[];
  highlighted: any;
  utils: any;
  sizeIcon

  searchIcon$ = new Subject<string>();
  sizeSelected = '';
  arrSize: string[];

  setSize(size) {
    this.sizeSelected = size
  }

  setIcon(icon) {

    this.sizeSelected = '';
    this.iconSelected = icon;
    this.component = `<span class="govco-icon govco-icon-${this.iconSelected}"></span>`
    // this.utils.scrollToTop('.cdn-scroll-dark');
    this.utils.callModal('icon');
    this.utils.sharpenBackgroundModal();

    this.searchIcon$.pipe(
      debounceTime(700),
      distinctUntilChanged(),
      switchMap(query => this.searchByIcon(query))
    ).subscribe((response: any) => {
      this.arrIconFilter = response;
    })

    this.updateContentModal();
  }

  searchByIcon(query: string) {
    return this.tools.searchInArray(this.arrIcon, query);
  }

  constructor(private highlightService: HighlightService, private tools: ToolsService) {

    this.utils = window.utils;
    this.arrIcon = [
      "tramite-sin-costo", "tramite-presencial", "tramite-en-linea", "tramite-duracion", "logo-govco-blanco", "logo-govco-negro", "tramite-con-costo",
      "exclamation", "exclamation-cn", "plus", "plus-p", "plus-n", "plus-cn", "plus-cp", "minus", "minus-cn", "minus-cp", "analytic", "analytic-p", "analytic-n", "analytic-cn",
      "idea", "idea-cn", "searchdoc", "call-center", "call-center-p", "call-center-n", "call-center-cn", "call-center-cp", "share", "share-cn", "share-p", "share-n", "circle-share-cp", "circle-share-cn",
      "dropdown", "dropdown-cn", "callback-cn", "callback-cp", "building", "favorite", "favorite-cn", "favorite-p", "favorite-n", "pc", "print", "print-cn", "print-p",
      "print-n", "info", "info-cn", "info-cp", "legal", "key", "key-cn", "key-cp", "email", "email-p", "email-n", "email-cp", "email-cn", "message", "message-cn",
      "like", "like-cn", "like-p", "like-n", "pin", "pin-cn", "question", "question-cn", "questions-p", "questions-n", "clock", "clock-p", "clock-n", "telephone", "wifi-cn", "wifi-cp",
      "wifi-p", "wifi-n", "callin-n", "callin-p", "callin-cn", "callin-cp", "accessibility-cp", "accessibility-cn", "attached-p", "attached-n", "scared-face", "sad-face", "sad-face-n", "shock-face",
      "happy-face", "happy-face-n", "bell-p", "bell-n", "bell-sound-p", "bell-sound-n", "grad-cap-p", "grad-cap-n", "x-n", "x-p", "x-cn", "delete-p", "delete-n", "tag-p", "tag-n", "search-p",
      "search-n", "search-cp", "search-cn", "calendar-p", "calendar-n", "calendar-cp", "calendar-cn", "shop-car", "shop-car-n", "shop-car-p", "relief-p", "relief-n", "check-p", "check-n", "check-cp",
      "check-cn", "simpled-arrow", "simpler-arrow", "right-arrow", "right-arrow-p", "right-arrow-n", "right-arrow-cp", "right-arrow-cn", "shortr-arrow", "shortr-arrow-cn",
      "left-arrow", "left-arrow-cn", "shortl-arrow", "shortl-arrow-cn", "down-arrow-p", "down-arrow-n", "shortd-arrow-p", "shortd-arrow-n", "shortu-arrow-p", "shortu-arrow-n",
      "colombia-p", "colombia-n", "shield-col-p", "shield-col-n", "peso-col", "peso-col-p", "peso-col-n", "peso-col-cp", "peso-col-cn", "contrast-p", "contrast-n", "music-p", "music-n", "4-phases-p", "4-phases-n", "3-phases-p",
      "3-phases-n", "data-up-p", "data-up-n", "document-p", "document-n", "edit-slim-p", "edit-slim-n", "edit-p", "edit-n", "padlock-p", "padlock-n", "link-p", "link-n", "language-es-p",
      "language-es-n", "language-en-p", "language-en-n", "statistics-p", "statistics-n", "save-p", "save-n", "hand-p", "hand-n", "home-p", "home-n", "image-p", "image-n", "movil-cp",
      "movil-cn", "pitch-p", "pitch-n", "eye-p", "eye-n", "play", "play-cp", "play-cn", "pause", "social-p", "social-n", "reload-p", "reload-n", "answer-p", "answer-n", "sound-p", "sound-n", "table-p",
      "table-n", "more-size-p", "more-size-n", "less-size-p", "less-size-n", "user-p", "user-n", "video-p", "video-n",
    ];
    this.arrSize = ['size-1x', 'size-2x', 'size-3x', 'size-4x', 'size-5x'];
    this.arrIconFilter = this.arrIcon;
    this.setIcon(this.arrIcon[4]);

    this.component = `<span class="govco-icon govco-icon-${this.iconSelected}"></span>`;
    this.infoComponent = {
      titulo: "Símbolos e íconos",
    }



  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {
    window.utils.init();
  }

  updateContentModal() {
    const dataModal = {
      id: 'modal-iconos',
      name: this.iconSelected,
      content: `      
<div class="row">
  <div class="col-2">
      <div class="item-size-no-flex">
          <p>Tamaño por defecto</p>
          <span class="govco-icon govco-icon-${this.iconSelected} size-2x">
          </span>
      </div>
  </div>
  <div class="col-10">
      <pre _ngcontent-mmo-c4=""
          class=" line-numbers language-html"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>span</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>govco-icon govco-icon-${this.iconSelected}<span class="token punctuation">"</span></span><span class="token punctuation">&gt;</span></span><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>span</span><span class="token punctuation">&gt;</span></span><span aria-hidden="true" class="line-numbers-rows"><span></span></span></pre>
  </div>
</div>
<hr>
<div class="col-12">
  <div class="icon-item-size">
      ${(this.arrSize.map((size: any)=> {
        return `<div class="item-size">
  <p>${size}</p>
  <span class="govco-icon govco-icon-${this.iconSelected} ${size}">
  </span>
</div>`
      })).reduce((a,b) => a + b)}
     
  </div>
</div>`
    }
    this.tools.updateModalContent(dataModal);
  }
}